<div class="{{ className }}">
  <h2 class="{{ theme }} modal__title">Change image</h2>
  <mat-dialog-content class="{{ theme }} {{ className }}__body">
    <div class="{{ theme }} {{ className }}__cropper">
      <image-cropper
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded()"
        (loadImageFailed)="loadImageFailed()"
        [aspectRatio]="ratio"
        [containWithinAspectRatio]="false"
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="true"
        [onlyScaleDown]="true"
        [output]="'base64'"
        [resizeToHeight]="heightImage"
        [resizeToWidth]="widthImage"
        [transform]="transform"
        backgroundColor="#000000"
        class="{{ theme }} image-cropper"
        format="png"></image-cropper>
    </div>

    <div class="{{ theme }} {{ className }}__zoom-icons">
      <button
        (click)="zoomOut()"
        class="{{ className }}__zoom-button big"
        color="accent"
        id="zoomOur-img"
        mat-icon-button>
        <mat-icon class="{{ className }}__zoom-icon material-icon-outlined">zoom_out</mat-icon>
      </button>
      <mat-slider
        #ngSlider
        [discrete]="true"
        [max]="zoomMax"
        [min]="zoomMin"
        class="{{ className }}__zoom-slider"
        color="primary"
        id="zoomSlider-img"
        step="0.1">
        <input
          #ngSliderThumb="matSliderThumb"
          (change)="
            updateSettings({ source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value })
          "
          [value]="scale"
          matSliderThumb />
      </mat-slider>
      <button
        (click)="zoomIn()"
        class="{{ className }}__zoom-button big"
        color="accent"
        id="zoomIn-img"
        mat-icon-button>
        <mat-icon class="{{ className }}__zoom-icon material-icon-outlined">zoom_in</mat-icon>
      </button>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="{{ theme }} {{ className }}__footer">
    <div class="{{ theme }} {{ className }}__footer-wrapper">
      <button
        (click)="back()"
        class="{{ className }}__button-cancel big"
        color="accent"
        id="{{ className }}-button-cancel"
        mat-button
        mat-dialog-close>
        {{ labels.cancel }}
      </button>
    </div>
    <div class="{{ theme }} {{ className }}__footer-wrapper">
      <button
        (click)="onConfirmed()"
        class="{{ className }}__button-create big"
        color="accent"
        id="{{ className }}-button-upload"
        mat-flat-button>
        {{ labels.upload }}
      </button>
    </div>
  </mat-dialog-actions>
</div>